"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _moment = _interopRequireDefault(require("moment"));
var _GermanDateHelpers = require("../../../../utils/GermanDateHelpers");
var _GlobalErrorHandler = _interopRequireDefault(require("../../../../utils/GlobalErrorHandler"));
var _meterReadingFormHelper = require("../Anonym/MeterReadingForm/meterReadingFormHelper");
var _meterReadingDateInputHelper = require("../Core/MeterReadDateInput/meterReadingDateInputHelper");
var hasFormatError = function hasFormatError(inputValue) {
  if (inputValue) {
    if (inputValue.search(/\B[^0-9]/g) !== -1) {
      return false;
    }
    var positionOfFirstComma = inputValue.indexOf(',');
    var positionOfFirstDot = inputValue.indexOf('.');
    if (positionOfFirstDot !== -1 && positionOfFirstComma !== -1) {
      return true;
    }
    var dotSplitValues = inputValue.split('.');
    var commaSplitValues = inputValue.split(',');
    if (positionOfFirstDot !== -1) {
      for (var i = 0; i < dotSplitValues.length; i += 1) {
        var valueLength = dotSplitValues[i].length;
        if (valueLength > 3 || valueLength < 1) {
          return false;
        }
        if (i !== 0 && dotSplitValues[i].length < 3) {
          return false;
        }
      }
    }
    if (positionOfFirstComma !== -1) {
      if (commaSplitValues.length - 1 > 1) {
        return false;
      }
      if (commaSplitValues.length - 1 === 1) {
        if (positionOfFirstDot !== -1) {
          var lastDotPosition = 0;
          var positionOfDots = dotSplitValues.map(function (value) {
            lastDotPosition = value.length + lastDotPosition + 1;
            return lastDotPosition;
          });
          if (positionOfDots.some(function (item) {
            return item > positionOfFirstComma;
          })) {
            return false;
          }
        }
      }
    }
    return true;
  }
  return false;
};
var hasCommaBeforePeriod = function hasCommaBeforePeriod(inputValue) {
  if (inputValue) {
    var dotIndex = inputValue.indexOf('.');
    var commaIndex = inputValue.indexOf(',');
    return dotIndex === -1 || commaIndex === -1 || dotIndex < commaIndex;
  }
  return false;
};
var hasIncorrectDecimalLength = function hasIncorrectDecimalLength(numberOfDecimalPlaces, inputValue) {
  if (inputValue && inputValue.indexOf(',') !== -1) {
    var decimalPlaces = inputValue.split(',')[1];
    if (decimalPlaces) {
      return decimalPlaces.length <= numberOfDecimalPlaces;
    }
  }
  return true;
};
var hasIncorrectPreDecimalLength = function hasIncorrectPreDecimalLength(numberOfPreDecimalPlaces, inputValue) {
  if (inputValue) {
    var preDecimalPlaces = inputValue.replace(/\./g, '').split(',')[0];
    if (preDecimalPlaces) {
      return preDecimalPlaces.length <= numberOfPreDecimalPlaces;
    }
  }
  return false;
};
var validate = function validate(values, props) {
  var _values$readingDate, _errors$registers;
  var readingPeriod = (0, _meterReadingDateInputHelper.calculateReadingPeriod)(values.readingPeriod);
  var readingDate = values === null || values === void 0 ? void 0 : (_values$readingDate = values.readingDate) === null || _values$readingDate === void 0 ? void 0 : _values$readingDate.text;
  var errors = {
    readingDate: undefined,
    registers: []
  };
  if (!readingDate || !(0, _moment.default)(readingDate, _GermanDateHelpers.DATE_FORMAT, true).isValid()) {
    errors.readingDate = _GlobalErrorHandler.default.getErrorMessage('required').toString();
  }
  if ((0, _moment.default)(readingDate, _GermanDateHelpers.DATE_FORMAT, true).isBefore(readingPeriod.startDate)) {
    errors.readingDate = props.dateRangeErrorMsg;
  }
  if ((0, _moment.default)(readingDate, _GermanDateHelpers.DATE_FORMAT, true).isAfter(readingPeriod.endDate)) {
    errors.readingDate = props.futureDateErrorMessage;
  }
  values.registers.forEach(function (register, index) {
    if (!register.readingResult || register.readingResult === '') {
      errors.registers[index] = {
        readingResult: _GlobalErrorHandler.default.getErrorMessage('required').toString()
      };
      return;
    }
    if (!hasFormatError(register.readingResult ? register.readingResult.toString() : '')) {
      errors.registers[index] = {
        readingResult: props.meterFormatErrorMsg
      };
      return;
    }
    var registerData = (0, _meterReadingFormHelper.pickRegisterFromDeviceByRegisterNumber)(register.registerNumber, props.deviceData.registers);
    if (registerData) {
      if (!hasCommaBeforePeriod(register.readingResult ? register.readingResult.toString() : '')) {
        errors.registers[index] = {
          readingResult: props.dontUseCommaOrDotError
        };
        return;
      }
      if (!hasIncorrectDecimalLength(registerData.numberOfDecimalPlaces, register.readingResult ? register.readingResult.toString() : '')) {
        errors.registers[index] = {
          readingResult: props.decimalLengthError.replace('%%MAXDECIMALLENGTH%%', (registerData.numberOfDecimalPlaces || '').toString())
        };
        return;
      }
      if (!hasIncorrectPreDecimalLength(registerData.lengthIntegerPart, register.readingResult ? register.readingResult.toString() : '')) {
        errors.registers[index] = {
          readingResult: props.maximumPreDecimalPlaces.replace('%%MAXINTEGERLENGTH%%', (registerData.lengthIntegerPart || '').toString())
        };
      }
    }
  });
  if ((errors === null || errors === void 0 ? void 0 : (_errors$registers = errors.registers) === null || _errors$registers === void 0 ? void 0 : _errors$registers.length) === 0 && (errors === null || errors === void 0 ? void 0 : errors.readingDate) === undefined) {
    return undefined;
  }
  return errors;
};
var _default = exports.default = validate;